import React, { memo } from 'react';
import { Divider } from 'antd';
import PropTypes from 'prop-types';

import '../../assets/scss/index.scss';

const AuthWrapper = ({ 
  children, 
  title = '', 
  note = '', 
  footerLink = null 
}) => {
  return (
    <div className='bookroad-signup-tab-content'>
    {title && (
      <h2 className='bookroad-signup-tab-title manrope-16-bold text-center mb-16'>
        {title}
      </h2>
    )}
      {note && (
      <div className='bookroad-signup-tab-note radius-8 mb-16 py-12 px-16'>
        <p className='bookroad-signup-tab-notetext text-justify m-0'>
          {note}
        </p>
      </div>
    )}
      {children}
      {footerLink &&(
        <>
          <Divider className='mt-20 mb-10' />
          {footerLink}
        </>
      )}
    </div>
  );
};

AuthWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  note: PropTypes.string,
  footerLink: PropTypes.node,
};

export default memo(AuthWrapper);
